import React, { ReactElement, useState } from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import Form from "./Form";
import PageWrapper from "../../../ui/pageWrapper/PageWrapper";
import { FormMessageInItState } from "../../../constants";
import FormAlert from "../../../ui/formAlert/FormAlert";
import {
  createCompanyFormInitState,
  handleCreateCompanyFormSubmit,
} from "./utils";
import useValidation from "../../../hooks/useValidation";
import { route } from "../../../utils/url";
import { Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Index = (): ReactElement => {
  const navigate = useNavigate();
  const [formMessage, setFormMessage] = useState(FormMessageInItState);
  const [initialValues] = useState(createCompanyFormInitState);
  const { notes, object_name, location } =
    useValidation();
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      to: route("root"),
      name: "Dashboard",
    },
    {
      to: route("companies"),
      name: t("company.companies"),
    },
  ];

  return (
    <PageWrapper title={t("company.createCompany")} breadcrumbs={breadcrumbs}>
      <>
        <Grid container justifyContent={"center"}>
          <Grid item xs={12} md={12} lg={10} xl={8}>
            <Paper sx={{ padding: 6 }}>
              {formMessage.text && (
                /* istanbul ignore next */
                <FormAlert
                  formMessage={formMessage}
                  sx={{ marginBottom: "10px" }}
                />
              )}
              <Formik
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                  notes,
                  object_name,
                  location,
                })}
                onSubmit={handleCreateCompanyFormSubmit({
                  setFormMessage,
                  navigate,
                })}
              >
                {(props): ReactElement => <Form {...props} />}
              </Formik>
            </Paper>
          </Grid>
        </Grid>
      </>
    </PageWrapper>
  );
};

export default Index;
